import { ClassValue } from 'clsx';
import { Text } from '@shared/components/Text';
import { TextField } from '@shared/data/entity/fields/TextField';
import { CollectionViewFieldContainer } from './CollectionViewFieldContainer';
import { FieldVariant } from './FieldVariant';
import styles from './TextCollectionViewField.module.css';

interface Props {
  variant: FieldVariant;
  className?: ClassValue;
  field: TextField;
}

/**
 * Default: two lines, or four for long text, keeping its newlines. Compact: the text, unclamped;
 * the host decides how many lines it gets. Inline: as text.
 */
export function TextCollectionViewField({ field, variant, className }: Props) {
  if (field.isEmpty) {
    return null;
  }

  const isInline = variant === 'inline';
  const isCompact = variant === 'compact';
  const isDefault = variant === 'default';

  return (
    <CollectionViewFieldContainer
      fieldType={field.fieldType}
      variant={variant}
      multiline={isDefault && field.multiline}
      className={[styles.textCollectionViewField, className]}
    >
      {isInline && <InlineText field={field} />}
      {isCompact && <CompactText field={field} />}
      {isDefault && <DefaultText field={field} />}
    </CollectionViewFieldContainer>
  );
}

function InlineText({ field }: { field: TextField }) {
  return <>{field.value}</>;
}

function CompactText({ field }: { field: TextField }) {
  return <Text>{field.value}</Text>;
}

function DefaultText({ field }: { field: TextField }) {
  return (
    <Text data-slot="text" size="body1" numberOfLines={field.multiline ? 4 : 2}>
      {field.value}
    </Text>
  );
}
